<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    let {
        value = '', // The specific value for this radio button instance
        groupValue = $bindable(), // The shared, bound value for the radio group
        name = '', // The name for the radio group
        class: cls = '', // Additional classes for the label
        children,
        showIcon = false
    } = $props();

    const labelCls = $derived(twMerge("tw:relative tw:w-full tw:flex tw:items-center tw:gap-2 tw:cursor-pointer tw:has-focus-visible:outline-2 tw:outline-offset-2", cls));

    /* Ring und Punkt ohne eigene CSS-Regel — der Punkt ist ein ::after, das erst mit
       gesetztem Eingabefeld sichtbar wird. Die Farbe folgt dem Zustand: ungewaehlt grau,
       gewaehlt gruen. Die Tokens sind die des Themes (line / light-green) — --color-green gibt es
       dort nicht, die Klassen waeren sonst leer entstanden. */
    const punktCls = "tw:relative tw:shrink-0 tw:size-4 tw:rounded-full tw:border-2 tw:border-solid tw:border-line tw:peer-checked:border-light-green"
        + " tw:after:content-[''] tw:after:absolute tw:after:top-1/2 tw:after:left-1/2 tw:after:size-2"
        + " tw:after:-translate-x-1/2 tw:after:-translate-y-1/2 tw:after:rounded-full tw:after:bg-light-green"
        + " tw:after:opacity-0 tw:peer-checked:after:opacity-100";
</script>

<label class={labelCls}>
    <input type="radio"
           class="tw:peer tw:absolute tw:-z-10 tw:opacity-0"
           {value}
           name={name}
           checked={groupValue === value}
           onchange={() => groupValue = value}>
    {#if showIcon}
        <!-- decision: [1] eigene Marke
             ⚠️ DIREKT NACH dem Eingabefeld: `tw:peer-checked:*` ist ein Geschwister-
             Selektor. Im frueheren Aufbau lag die Marke eine Ebene tiefer, damit haette
             der gewaehlte Zustand sie nie erreicht. -->
        <span class={punktCls} aria-hidden="true"></span>
    {/if}
    <span class="tw:flex tw:gap-3 tw:items-center">
        {@render children()}
    </span>
</label>